<template>
  <li class="hotelRecommendListItem">
    <a :href="link">
      <figure class="hotelRecommendImage"><img :src="imageUrl" /></figure>
      <div class="hotelRecommendText">
        <h4>{{ name }}</h4>
        <p><span class="starRate">★</span>{{ starNumber }}つ星</p>
        <p class="hotelRecommendPrice">
          <span class="fontNo">{{ price }}</span
          >円～<span class="nights">({{ personNumber }}名{{ stayDay }}泊)</span>
        </p>
      </div>
    </a>
  </li>
</template>

<script>
export default {
  name: 'RecommendHotelCard',
  props: {
    name: {
      type: String,
      required: true,
    },
    price: {
      type: String,
      required: true,
    },
    starNumber: {
      type: Number,
      default: 0,
    },
    personNumber: {
      type: Number,
      required: true,
    },
    stayDay: {
      type: Number,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      default: '',
    },
  },
}
</script>
